<script setup lang="ts">
import Clouds from '~/assets/startup/clouds.svg?component'
import Rocket from '~/assets/startup/rocket.svg?component'
import StartUpBg from '~/assets/startup/start-up-bg.svg?component'
import StartUpBgElements from '~/assets/startup/start-up-bg-elements.svg?component'
import { Motion, Presence } from 'motion/vue'
const {
  public: { baseUrl },
} = useRuntimeConfig()

const { defineOgMeta } = useSeoAttributes()
const pageMeta = usePageMeta()

const { pending, data } = await useAsyncData('meta-startup', async () => pageMeta.fetchByPath('/startup'))
if (data.value) {
  useHead(() => ({
    title: data.value?.title,
    meta: [...defineOgMeta(data?.value)],
    link: [{ rel: 'canonical', href: `${baseUrl}/startups` }],
  }))
}

const { t } = useI18n()

const info = {
  landing: {
    title: t('startup.title'),
    subTitle: t('startup.subtitle'),
    desc: t('startup.description'),
  },
  connect: {
    title: t('startup.connect.title'),
    description: t('startup.connect.description'),
  },
}
const phrase = ref('')

const updateWord = () => {
  phrase.value = t(`startup.phrases.${Math.floor(Math.random() * 3)}`)
}
onMounted(() => {
  updateWord()
  setInterval(updateWord, 3000)
})
</script>

<template>
  <Loader :pending="pending">
    <Container class="screen-content relative px-0 pb-32">
      <LayoutPageHeader :title="info.landing.title" :grid="false" class="-mt-32 pt-32">
        <template #description>
          <Presence>
            <Motion
              class="absolute"
              :key="phrase"
              :initial="{ opacity: 0, x: 50 }"
              :animate="{
                opacity: 1,
                x: 0,
                transition: { delay: 0.1 },
              }"
              :exit="{ opacity: 0, x: -50 }"
            >
              {{ phrase }}
            </Motion>
          </Presence>
        </template>
      </LayoutPageHeader>

      <div class="flex flex-col items-center px-2">
        <StartUpBgElements
          class="mx absolute left-1/2 top-[28.1rem] z-[-1] h-[572px] w-full max-w-[1920px] -translate-x-1/2 -translate-y-1/2 transform md:top-[28.5em]"
        />
        <StartUpBg
          class="mx absolute left-1/2 top-[34.4rem] z-[-20] h-[775px] min-w-[1920px] -translate-x-1/2 -translate-y-1/2 transform md:top-[34.7rem]"
        />
        <Motion
          class="absolute z-[-10] mx-auto h-[660px] w-[592px] transform"
          :initial="{ y: 600, opacity: 0 }"
          :animate="{ y: 64, opacity: 1 }"
          :transition="{ duration: 1, easing: [0.16, 1, 0.3, 1] }"
        >
          <Rocket />
        </Motion>

        <Clouds
          class="mx absolute left-1/2 top-[60.6rem] z-[-20] h-[805px] w-full min-w-[1920px] -translate-x-1/2 -translate-y-1/2 transform md:top-[61rem]"
        />

        <div class="mb-32 px-6 text-center">
          <div class="xs:mt-[34rem] inline-block md:mt-[30rem] md:w-2/4 lg:mt-[35.5rem]">
            <Heading as="h2" size="big" gradient="gray">{{ info.landing.subTitle }} </Heading>
            <Paragraph size="large" class="mt-8">{{ info.landing.desc }} </Paragraph>
          </div>
        </div>

        <StartUpForm class="mb-32" />

        <StartUpSteps class="w-full max-w-full px-4" />

        <div class="lsg:gap-32 mt-[8rem] flex w-full flex-wrap justify-center gap-60 xl:gap-60">
          <WBottomCard
            :title="$t('projects.title')"
            :eyebrow="$t('common.card.projects.eyebrow')"
            section-link="/projects"
            image-link="/art-projects.svg"
          />
          <WBottomCard
            :title="$t('common.card.services.title')"
            :eyebrow="$t('common.card.services.eyebrow')"
            section-link="/services"
            image-link="/art-team.svg"
          />
        </div>
      </div>
    </Container>
  </Loader>
</template>
